// MACHINERY V2 (Stroje) — profile pill tabs (M2.4).
//
// Spec: MACHINERY_V2_IMPLEMENTATION_TICKET.md §8 M2.4; reference impl
// design_handoff_machinery_v3/machinery-profile-mash.jsx (pill tab row) +
// artboard 0504. Pills: 34px tall, fully rounded, active = module teal fill.
//
// PRESENTATIONAL ONLY. Which tabs exist and which one is active are decided in
// profileTabContract.ts and owned by MachineProfileV2 — this component paints the list
// it is handed. That is why a tab can never be rendered here that the gate
// upstream would have hidden.
//
// The hero flows DIRECTLY into this row: no KPI strip sits between them
// (§9 D3 — the artboard's 4 tiles are cut).
//
// 0504 also draws a "VIAC ·" affordance at the right end of this row. It is NOT
// built: it exists in the artboard to overflow a tab list, and our five pills
// fit. Nothing is hidden behind it, so an affordance that reveals nothing would
// be chrome for its own sake.
//
// No Tailwind, no shadcn, no MUI, no @emotion, no sx, no dt tokens.
import React from "react";

import useTranslation from "../../../../shared/hooks/useTranslation";
import {
  MachineryV2ProfileTab,
  PROFILE_TAB_LABEL_KEYS,
} from "./profileTabContract";

export interface ProfileTabsProps {
  tabs: MachineryV2ProfileTab[];
  active: MachineryV2ProfileTab;
  onChange: (tab: MachineryV2ProfileTab) => void;
}

const ProfileTabs: React.FC<ProfileTabsProps> = ({ tabs, active, onChange }) => {
  const { translate } = useTranslation("myMachinery");

  return (
    <div
      role="tablist"
      aria-label={translate("myMachinery:v2.profile.tabsLabel")}
      style={{
        display: "flex",
        gap: 4,
        alignItems: "center",
        flexWrap: "wrap",
        minWidth: 0,
      }}
    >
      {tabs.map((tab) => {
        const on = tab === active;
        return (
          <button
            key={tab}
            type="button"
            role="tab"
            aria-selected={on}
            id={`machinery-v2-tab-${tab}`}
            aria-controls="machinery-v2-tabpanel"
            onClick={() => onChange(tab)}
            style={{
              height: 34,
              padding: "0 14px",
              borderRadius: 999,
              border: "1px solid " + (on ? "var(--mod-accent)" : "transparent"),
              background: on ? "var(--mod-accent)" : "transparent",
              color: on ? "var(--mod-accent-fg)" : "var(--muted)",
              fontFamily: "inherit",
              fontSize: 13,
              fontWeight: on ? 600 : 500,
              cursor: "pointer",
              whiteSpace: "nowrap",
              transition: "background 0.12s, color 0.12s, border-color 0.12s",
            }}
          >
            {translate(PROFILE_TAB_LABEL_KEYS[tab])}
          </button>
        );
      })}
    </div>
  );
};

export default ProfileTabs;
